import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[adHost]',
})
export class AdComponent {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
